module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table",
    staticStyle: {
      "background-color": "rgba(0, 0, 0, 0.0)",
      "color": "white",
      "border": "none"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('td', [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.name)
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "block"
  }, [_c('b-icon', {
    attrs: {
      "icon": "account",
      "size": "is-medium"
    }
  })], 1)]), _vm._v(" "), _c('td', [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.about)
    }
  })])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('ul', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('li', [_vm._v("Bachelor of Science in Accountancy from"), _c('b-tooltip', {
    attrs: {
      "label": "Arizona State University",
      "position": "is-right"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("ASU")])]), _vm._v("\n                    - 2011"), _c('br'), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "label": "with the highest distinction",
      "position": "is-right"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Graduated Summa Cum Laude")])])], 1), _vm._v(" "), _c('li', [_vm._v("Master of Accountancy (MACC) from"), _c('b-tooltip', {
    attrs: {
      "label": "Arizona State University",
      "position": "is-right"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("ASU")])]), _vm._v(" - 2012")], 1), _vm._v(" "), _c('li', [_vm._v("Work in Public Accounting Field - Since 2012")]), _vm._v(" "), _c('li', [_vm._v("Teach IRS Financial & Tax Series - Since 2015")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "block"
  }, [_c('b-icon', {
    attrs: {
      "icon": "briefcase-variant",
      "size": "is-medium"
    }
  })], 1)]), _vm._v(" "), _c('td', [_c('h2', [_vm._v(_vm._s(_vm.work))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "block"
  }, [_c('b-icon', {
    attrs: {
      "icon": "mailbox",
      "size": "is-medium"
    }
  })], 1)]), _vm._v(" "), _c('td', [_c('h2', [_vm._v(_vm._s(_vm.address1))])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('h2', [_vm._v(_vm._s(_vm.address2))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "block"
  }, [_c('b-icon', {
    attrs: {
      "icon": "phone-classic",
      "size": "is-medium"
    }
  })], 1)]), _vm._v(" "), _c('td', [_c('h2', [_vm._v(_vm._s(_vm.phone1) + " - " + _vm._s(_vm.phone2))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "block"
  }, [_c('b-icon', {
    attrs: {
      "icon": "email",
      "size": "is-medium"
    }
  })], 1)]), _vm._v(" "), _c('td', [_c('h2', [_vm._v(_vm._s(_vm.email))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b21983c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/Profile.vue
// module id = 519
// module chunks = 1